export default class SearchParams {
  constructor({
    destinationId,
    activities,
    ambiances,
    transports,
    travellers,
    seasons,
    media,
    page,
    username,
    excludeNameIds
  } = {}) {
    this.destinationId = destinationId;
    this.activities = activities || [];
    this.ambiances = ambiances || [];
    this.transports = transports || [];
    this.travellers = travellers || [];
    this.seasons = seasons || [];
    this.page = parseInt(page) || 1;
    this.media = media || [];
    this.username = username || "";
    this.excludeNameIds = excludeNameIds || [];
  }
  getDataForNewSearch() {
    return {
      destinationId: this.destinationId,
      page: this.page,
      media: this.media.map(x => x.nameEn),
      seasons: this.seasons.map(x => x.nameEn),
      themes: []
        .concat(
          this.activities,
          this.ambiances,
          this.transports,
          this.travellers
        )
        .map(x => x.nameEn),
      username: this.username,
      excludeNameIds: this.excludeNameIds
    };
  }
}
